import React from 'react';

const PDLocalStreak = () => {
    return (
        <div className="space-y-4">
            {/* HERO */}
            <div className="bg-gradient-to-r from-cyan-900/30 to-purple-900/30 border border-cyan-800 rounded-xl p-2">
                <h2 className="text-sm lg:text-lg text-cyan-200 font-semibold mb-2">
                    🏪 PurpleDoor FindItLocal Merchant Streaks
                </h2>
                <p className="text-gray-100 text-xs lg:text-sm">
                    PurpleDoor FindItLocal Merchant Streaks bridges the gap between digital consumer behaviour and local businesses through a simple, engaging and rewarding streak economy.
                </p>
                <p className="text-gray-100 text-xs lg:text-sm mt-2">
                    Inspired by the success of streaks in learning apps, fitness platforms, gaming and social media, Merchant Streaks brings the same engagement model to local commerce.
                </p>
            </div>
            {/* USER BENEFITS */}
            <div className="bg-gray-800/70 border border-gray-700 rounded-xl p-2">
                <h2 className="text-sm lg:text-lg text-cyan-200 font-semibold mb-1">
                    👥 Benefits for Users
                </h2>

                <ul className="list-disc pl-5 space-y-2">
                    <li className="text-gray-100 text-xs lg:text-sm">
                        Discover nearby local businesses and service providers.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Build streaks through purchases, referrals, reviews and visits.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Earn recognition for consistent engagement.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Unlock discounts, cashback opportunities and exclusive offers.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Support local businesses while receiving real value.
                    </li>
                </ul>
            </div>

            {/* MERCHANT BENEFITS */}
            <div className="bg-gray-800/70 border border-gray-700 rounded-xl p-2">
                <h2 className="text-sm lg:text-lg text-cyan-200 font-semibold mb-1">
                    📈 Benefits for Local Merchants
                </h2>

                <ul className="list-disc pl-5 space-y-2">
                    <li className="text-gray-100 text-xs lg:text-sm">
                        Increase repeat customer visits and purchases.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Build long-term customer loyalty.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Encourage reviews, referrals and community participation.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Reduce customer acquisition costs.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Leverage the proven engagement power of the streak economy.
                    </li>
                </ul>
            </div>

            {/* HOW IT WORKS */}
            <div className="bg-gray-800/70 border border-gray-700 rounded-xl p-2">
                <h2 className="text-sm lg:text-lg text-cyan-200 font-semibold mb-1">
                    ⚡ How Merchant Streaks Work
                </h2>

                <ol className="space-y-2 list-decimal pl-5">
                    <li className="text-gray-100 text-xs lg:text-sm">
                        User completes an eligible merchant activity.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Merchant verifies and approves the activity.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Approved activity converts into Merchant Streak Credits.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Consistent engagement builds stronger streaks.
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        Users redeem approved streaks for merchant rewards.
                    </li>
                </ol>
            </div>

            {/* STREAK BACK */}
            <div className="bg-gradient-to-r from-purple-900/30 to-cyan-900/30 border border-purple-700 rounded-xl p-2">
                <h2 className="text-sm lg:text-lg text-cyan-200 font-semibold mb-1">
                    🎁 Streak Back Rewards
                </h2>

                <p className="text-gray-100 text-xs lg:text-sm">
                    PurpleDoor introduces the concept of Streak Back, where approved streak achievements can be redeemed for real-world benefits.
                </p>

                <ul className="list-disc pl-5 mt-2 space-y-2">
                    <li className="text-gray-100 text-xs lg:text-sm">
                        5 Approved Streaks → Merchant Discount
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        10 Approved Streaks → Special Offer
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        20 Approved Streaks → Loyalty Reward
                    </li>

                    <li className="text-gray-100 text-xs lg:text-sm">
                        50 Approved Streaks → VIP Recognition
                    </li>
                </ul>
            </div>

            {/* WHY IT WORKS */}
            <div className="bg-gray-800/70 border border-gray-700 rounded-xl p-2">
                <h2 className="text-sm lg:text-lg text-cyan-200 font-semibold mb-1">
                    🌟 Why It Works
                </h2>

                <p className="text-gray-100 text-xs lg:text-sm">
                    People naturally respond to progress, achievement, recognition and rewards. Merchant Streaks transforms routine transactions into an engaging journey that benefits consumers, merchants and local communities alike.
                </p>
            </div>

            {/* VISION */}
            <div className="bg-gradient-to-r from-cyan-900/30 to-purple-900/30 border border-cyan-800 rounded-xl p-2">
                <h2 className="text-sm lg:text-lg text-cyan-200 font-semibold mb-1">
                    🚀 PurpleDoor Vision
                </h2>

                <p className="text-gray-100 text-xs lg:text-sm">
                    PurpleDoor FindItLocal Merchant Streaks is more than a loyalty program. It is a community engagement ecosystem that combines digital-age streak motivation with real-world local commerce growth.
                </p>

                <p className="text-gray-100 text-xs lg:text-sm mt-2">
                    By connecting consumer engagement habits with neighbourhood businesses, PurpleDoor helps create stronger merchants, more loyal customers and thriving local communities.
                </p>
            </div>

        </div>
    );
};


export default PDLocalStreak;